import React, {useState} from 'react';
import Icon from '@Components/Icon';
import {injectIntl} from 'react-intl';

const NoticeText = ({intl, content}) => {
  const [collapse, setCollapse] = useState(false);

  const removeNotice = () => {
    setCollapse(true);
  };

  return (
    <>
      <div
        className={`block notice-text-only notice-text-only__closable bg-ui-warning ${collapse ? 'closable--closed' : ''}`}
        data-rs-notification-1=""
        data-rs-closable-fadeout=""
        style={{maxHeight: collapse ? 0 : `100vh`}}
      >
        <div className="wrapper notice-text-only__wrapper">
          <div className="notice-text-only__content">
            <div className="notice-text-only__close" data-rs-closable-fadeout="">
              <button className="button--icon-only" data-rs-closable="data-rs-notification-1" onClick={removeNotice}>
                <span className="icon icon--inline">
                  <Icon type="close-30"/>
                </span>
              </button>
            </div>
            <div className="notice-text-only__description pr-m" data-rs-closable-fadeout="">
              <div className="description l:flex">
                <p
                  className="mr-xs"
                  dangerouslySetInnerHTML={{__html: intl.formatMessage({id: content})}}/>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default injectIntl(NoticeText);
